import { render } from "./ProfileUserImage.vue?vue&type=template&id=01b37f45"
import script from "./ProfileUserImage.vue?vue&type=script&lang=js"
export * from "./ProfileUserImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__